import { render, staticRenderFns } from "./UIcon.vue?vue&type=template&id=331a70b0&scoped=true&"
import script from "./UIcon.vue?vue&type=script&lang=ts&"
export * from "./UIcon.vue?vue&type=script&lang=ts&"
import style0 from "./UIcon.vue?vue&type=style&index=0&id=331a70b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a70b0",
  null
  
)

export default component.exports